<template>

    <article id="app">
    <router-view v-slot="{ Component }">
        <component :is="Component" />
        <!--
            <keep-alive>
            </keep-alive>
        -->
    </router-view>
    </article>

</template>



<script>
export default {
    // created() {}
};
</script>

<style lang="scss">

    @import "@/common/scss/_variables.scss";

</style>
